import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  AssignmentCustomerResponse,
  BaseCoreState,
  ProfileDocumentResponse,
  BaseOrderDirectionEnum,
  BaseDocumentsService,
} from 'base';
import { DocumentsHeaderSortKeys } from '../../_enums/base-customer-header-sort-keys.enum';

@Component({
  selector: 'base-customer-employee-documents-tab',
  templateUrl: './base-customer-employee-documents-tab.component.html',
})
export class BaseCustomerEmployeeDocumentsTabComponent implements OnInit, OnDestroy {
  @Input() assignment: AssignmentCustomerResponse;
  documentList: Array<ProfileDocumentResponse & { categoryLabel?: string }> = [];
  documentsOrderDirection: BaseOrderDirectionEnum;
  documentsOrderKey: number;

  documentsHeaderSortKeys = DocumentsHeaderSortKeys;
  directions = BaseOrderDirectionEnum;
  documentCategories: { value: number; label: string }[] = [];

  private destroy$ = new Subject<boolean>();

  constructor(private store: Store<BaseCoreState>, private baseDocumentsService: BaseDocumentsService) {}

  ngOnInit() {
    this.getDocumentsCategories();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onDocumentsOrderChanged(key: number): void {
    if (this.documentList.length) {
      this.documentsOrderKey = key;
      this.documentsOrderDirection =
        !this.documentsOrderDirection || this.documentsOrderDirection === this.directions.desc
          ? this.directions.asc
          : this.directions.desc;
      this.orderDocuments();
    }
  }

  private getDocumentsCategories(): void {
    this.baseDocumentsService
      .getDocumentCategories('offer')
      .pipe(takeUntil(this.destroy$))
      .subscribe((categories) => {
        this.documentCategories = categories;

        this.documentList = this.assignment.documents.map((document) => ({
          ...document,
          categoryLabel: this.documentCategories.find((category) => category.value === document.category)?.label,
        }));
      });
  }

  private orderDocuments(): void {
    switch (this.documentsOrderKey) {
      case DocumentsHeaderSortKeys.name:
        this.documentList = [...this.documentList].sort((documentA, documentB) => {
          if (documentA.name === undefined && documentB.name === undefined) return 0;
          if (documentA.name === undefined) return -1;
          if (documentB.name === undefined) return 1;

          if (this.documentsOrderDirection === this.directions.asc) {
            return documentA.name.localeCompare(documentB.name);
          } else {
            return documentB.name.localeCompare(documentA.name);
          }
        });
        break;
      case DocumentsHeaderSortKeys.category:
        this.documentList = [...this.documentList].sort((documentA, documentB) => {
          if (!documentA.categoryLabel || !documentB.categoryLabel) {
            return 0;
          }

          if (this.documentsOrderDirection === this.directions.asc) {
            return documentA.categoryLabel.localeCompare(documentB.categoryLabel);
          } else {
            return documentB.categoryLabel.localeCompare(documentA.categoryLabel);
          }
        });
        break;
      case DocumentsHeaderSortKeys.validUntil:
        this.documentList = [...this.documentList].sort((documentA, documentB) => {
          if (this.documentsOrderDirection === this.directions.asc) {
            return new Date(documentA.validUntil!).getTime() - new Date(documentB.validUntil!).getTime();
          } else {
            return new Date(documentB.validUntil!).getTime() - new Date(documentA.validUntil!).getTime();
          }
        });
        break;
    }
  }
}
